import { render, staticRenderFns } from "./GridAdvertisedPrice.vue?vue&type=template&id=185acb4d&"
import script from "./GridAdvertisedPrice.vue?vue&type=script&lang=js&"
export * from "./GridAdvertisedPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports